/**
 * Category Configuration and Utilities
 *
 * 카테고리 관련 설정 및 유틸리티 함수
 */

import {
  Car,
  Smartphone,
  Plane,
  LucideIcon,
  Sparkles,
  Baby,
  Package,
} from "lucide-react";

// 카테고리 아이콘 매핑 (카테고리 코드별)
export const categoryIcons: Record<string, LucideIcon> = {
  10: Plane, // 여행, 액티비티
  20: Smartphone, // 테크, 스마트기기
  30: Sparkles, // 뷰티, 홈리빙
  40: Baby, // 키즈, 패밀리
  50: Car, // 모빌리티
  default: Package, // 기본 아이콘
};

/**
 * 카테고리 코드에 해당하는 아이콘 가져오기
 */
export function getCategoryIcon(categoryCode: string): LucideIcon {
  return categoryIcons[categoryCode] || categoryIcons.default || Package;
}

// 카테고리별 고유 색상 매핑
export const categoryColors: Record<string, { bg: string; iconColor: string }> = {
  "10": { bg: "bg-blue-50", iconColor: "text-blue-500" }, // 여행·액티비티
  "20": { bg: "bg-violet-50", iconColor: "text-violet-500" }, // 테크·스마트기기
  "30": { bg: "bg-pink-50", iconColor: "text-pink-500" }, // 뷰티·홈리빙
  "40": { bg: "bg-green-50", iconColor: "text-green-500" }, // 키즈·패밀리
  "50": { bg: "bg-amber-50", iconColor: "text-amber-500" }, // 모빌리티
};

export function getCategoryColor(code: string) {
  return (
    categoryColors[code] || { bg: "bg-orange-50", iconColor: "text-orange-500" }
  );
}

/**
 * 지도 핀 아바타 — 면은 브랜드, 형태는 종류.
 * 원은 전부 진한 주황(orange-600) 하나라 지도 위 핀이 한 브랜드로 읽히고, 카테고리
 * 구분은 흰 선 아이콘의 형태가 맡는다. 대분류별 색(파스텔 5색)은 정체성을 흩뜨려
 * 09-15 시안 비교(G1) 끝에 뺐다.
 *
 * 10-02: 연주황(orange-200)+검정 아이콘 → 진한 주황+흰 아이콘. 지도 바탕의 Google
 * 기본 명소 아이콘을 파스텔로 옅게 바꾸면서 우리 핀이 한 단계 앞에 보이도록.
 * orange-500(#f97316) 위 흰 아이콘은 대비 2.8:1 로 그래픽 기준 3:1 미달이라 600(3.6:1).
 */
export const CATEGORY_AVATAR_DISC = "#ea580c"; // orange-600
/** 핀 아바타 아이콘 선 색 — 흰색. 진한 주황·검정(선택) 원 위에서 형태를 또렷하게. */
export const CATEGORY_AVATAR_INK = "#ffffff";
/** 선택된 핀의 원 — neutral-900. 주황 핀들 사이에서 색 하나로 "고른 자리"가 갈린다. */
export const CATEGORY_AVATAR_DISC_SELECTED = "#171717";
